module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-29.fa35a319.jpg";